import React from "react";
import { useTranslation } from "react-i18next";

import { ERROR_PLACE } from "components/InputsField/InputError";
import {
    numberInput,
    floatNormalize9999,
    floatNormalize50,
} from "components/InputsField/inputFormats";
import FormRow from "components/common/Layout/FormRow";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";

function Dimensions() {
    const { t } = useTranslation();
    const getTranslate = (str) => t("cargoSearch.size_field." + str);

    return (
        <>
            <FormRow>
                <FormRow withSpace>
                    <FormRow withSpace withLine fromTo>
                        <FormikTextField
                            normalize={floatNormalize9999}
                            maxLength="6"
                            format={numberInput}
                            label={getTranslate("weight")}
                            name="weight_from"
                            placeholder={getTranslate("grey_from")}
                        />
                        <FormikTextField
                            normalize={floatNormalize9999}
                            maxLength="6"
                            label=" "
                            format={numberInput}
                            name="weight_to"
                            placeholder={getTranslate("grey_till")}
                            errorMode={ERROR_PLACE.bottomLeft}
                        />
                    </FormRow>
                    <FormRow withSpace withLine fromTo>
                        <FormikTextField
                            normalize={floatNormalize9999}
                            maxLength="6"
                            format={numberInput}
                            label={getTranslate("cubage")}
                            name="volume_from"
                            placeholder={getTranslate("grey_from")}
                        />
                        <FormikTextField
                            normalize={floatNormalize9999}
                            maxLength="6"
                            format={numberInput}
                            label=" "
                            name="volume_to"
                            placeholder={getTranslate("grey_till")}
                            errorMode={ERROR_PLACE.bottomLeft}
                        />
                    </FormRow>
                </FormRow>
                <FormRow withSpace withLine fromTo>
                    <FormikTextField
                        normalize={floatNormalize50}
                        maxLength="6"
                        format={numberInput}
                        label={getTranslate("length")}
                        name="length_from"
                        placeholder={getTranslate("grey_from")}
                    />
                    <FormikTextField
                        normalize={floatNormalize50}
                        maxLength="6"
                        format={numberInput}
                        name="length_to"
                        label=" "
                        placeholder={getTranslate("grey_till")}
                        errorMode={ERROR_PLACE.bottomLeft}
                    />
                </FormRow>
            </FormRow>
            <FormRow withMargin>
                <FormRow withSpace withLine fromTo>
                    <FormikTextField
                        normalize={floatNormalize50}
                        maxLength="6"
                        format={numberInput}
                        label={getTranslate("width")}
                        name="width_from"
                        placeholder={getTranslate("grey_from")}
                    />
                    <FormikTextField
                        normalize={floatNormalize50}
                        maxLength="6"
                        format={numberInput}
                        label=" "
                        name="width_to"
                        placeholder={getTranslate("grey_till")}
                        errorMode={ERROR_PLACE.bottomLeft}
                    />
                </FormRow>
                <FormRow withSpace withLine fromTo>
                    <FormikTextField
                        normalize={floatNormalize50}
                        maxLength="6"
                        format={numberInput}
                        label={getTranslate("height")}
                        name="height_from"
                        placeholder={getTranslate("grey_from")}
                    />
                    <FormikTextField
                        normalize={floatNormalize50}
                        maxLength="6"
                        format={numberInput}
                        label=" "
                        name="height_to"
                        placeholder={getTranslate("grey_till")}
                        errorMode={ERROR_PLACE.bottomLeft}
                    />
                </FormRow>
            </FormRow>
            <FormRow withMargin>
                <div>
                    <FormikCheckboxField
                        name="dont_show_without_dimensions"
                        id="dont_show_without_dimensions"
                        label={
                            <>
                                {getTranslate("size_box")}
                                <span className="info__logo" />
                            </>
                        }
                    />
                </div>
            </FormRow>
        </>
    );
}

export default Dimensions;
